import nft1 from "../../../../assets/img/nfts/Banner.png";

const Banner1 = () => {
    return (
        <div
            className="flex mt-4 w-full flex-col rounded-[20px] bg-cover px-[20px] py-[20px] md:px-[70px] md:py-[96px]"
            style={{backgroundImage: `url(${nft1})`}}
        >
            <div className="w-full">
                <style jsx>{`
                    @keyframes fadeInUp {
                        0% {
                            opacity: 0;
                            transform: translateY(30px);
                        }
                        100% {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }

                    .animate-fade-in-up {
                        animation: fadeInUp 0.6s ease-out;
                    }
                `}</style>

                {/* Main Heading */}
                <h2 className="mb-[28px] max-w-full text-[36px] font-extrabold leading-[44px] text-[#0f172a] md:w-[64%] md:text-[48px] md:leading-[58px] lg:w-[46%] xl:w-[85%] 2xl:w-[75%] 3xl:w-[52%] animate-fade-in-up opacity-0"
                    style={{animationDelay: '0s', animationFillMode: 'forwards'}}>
                    Your Kitchen,
                    <span className="block italic font-light text-[#004c86] mt-1">Reimagined</span>
                </h2>

                {/* Feature List */}
                <div
                    className="mb-[32px] max-w-full text-[19px] font-medium leading-[36px] text-white md:w-[64%] lg:w-[40%] xl:w-[72%] 2xl:w-[60%] 3xl:w-[45%]">
                    <p className="animate-fade-in-up opacity-0"
                       style={{animationDelay: '0.3s', animationFillMode: 'forwards'}}>
                        Blend fresh smoothies.
                    </p>
                    <p className="animate-fade-in-up opacity-0"
                       style={{animationDelay: '0.5s', animationFillMode: 'forwards'}}>
                        Fry guilt-free snacks.
                    </p>
                    <p className="animate-fade-in-up opacity-0"
                       style={{animationDelay: '0.7s', animationFillMode: 'forwards'}}>
                        Bake golden perfection.
                    </p>
                </div>

                {/* Tagline */}
                <div className="max-w-full md:w-[64%] lg:w-[40%] xl:w-[72%] 2xl:w-[60%] 3xl:w-[45%]">
                    <p className="animate-fade-in-up opacity-0 text-[25px] font-semibold text-amber-300"
                       style={{animationDelay: '0.9s', animationFillMode: 'forwards'}}>
                        All with one platform.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Banner1;
